import * as React from 'react';

export const gbFlagContent: JSX.Element = (
    <>
        <g clipPath='url(#clip0_11_4438)'>
            <rect
                width='28'
                height='20'
                rx='4'
                fill='#001B69'
            />
            <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M2.97863 0H0V3.33333L25.0052 20L28 20V16.6667L2.97863 0Z'
                fill='white'
            />
            <path
                d='M0.993465 0L28 18.0472V20H27.0298L0 1.93408V0H0.993465Z'
                fill='#C9072A'
            />
            <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M25.3334 3.05176e-05H28.0001V3.33336C28.0001 3.33336 10.6798 14.4374 2.66676 20H9.15527e-05V16.6667L25.3334 3.05176e-05Z'
                fill='white'
            />
            <path
                d='M28 0H27.0957L0 18.0628V20H0.993465L28 1.94868V0Z'
                fill='#C9072A'
            />
            <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M10.1828 0H17.8405V6.16909H28V13.8268H17.8405V20H10.1828V13.8268H0V6.16909H10.1828V0Z'
                fill='white'
            />
            <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M11.7895 0H16.2105V7.69231H28V12.3077H16.2105V20H11.7895V12.3077H0V7.69231H11.7895V0Z'
                fill='#C9072A'
            />
        </g>
        <defs>
            <clipPath id='clip0_11_4438'>
                <rect
                    width='28'
                    height='20'
                    rx='4'
                    fill='white'
                />
            </clipPath>
        </defs>
    </>
);
